import { ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'

export default function useAppCustomizer() {
  // Customizer
  const isCustomizerOpen = ref(false)

  // Skin
  const skinOptions = [
    { text: 'Açık', value: 'light' },
    { text: 'Çerçeveli', value: 'bordered' },
    { text: 'Koyu', value: 'dark' },
    { text: 'Yarı Koyu', value: 'semi-dark' },
  ]

  // Content Width Options
  const contentWidthOptions = [
    { text: 'Tam Genişlik', value: 'full' },
    { text: 'Kutucuk', value: 'boxed' },
  ]

  // Router Transition
  const routerTransitionOptions = [
    { title: 'Zoom', value: 'zoom-fade' },
    { title: 'Solma', value: 'fade' },
    { title: 'Aşağı Solma', value: 'fade-bottom' },
    { title: 'Kayarak Solma', value: 'slide-fade' },
    { title: 'Ters Zoom', value: 'zoom-out' },
    { title: 'Efektsiz', value: 'none' },
  ]

  // Router Transition
  const layoutTypeOptions = [
    { text: 'Dikey', value: 'vertical' },
    { text: 'Yatay', value: 'horizontal' },
  ]

  // Navbar
  const navbarColors = ['', 'primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark']

  // Navbar Types
  const navbarTypes = [
    { text: 'Sabit Olmayan', value: 'floating' },
    { text: 'Yapışık', value: 'sticky' },
    { text: 'Sabit', value: 'static' },
    { text: 'Gizli', value: 'hidden' },
  ]

  // Footer Types
  const footerTypes = [
    { text: 'Yapışkan', value: 'sticky' },
    { text: 'Sabit', value: 'static' },
    { text: 'Gizli', value: 'hidden' },
  ]

  // eslint-disable-next-line object-curly-newline
  const {
    isRTL,
    skin,
    contentWidth,
    routerTransition,
    layoutType,
    isNavMenuHidden,
    isVerticalMenuCollapsed,
    navbarBackgroundColor,
    navbarType,
    footerType,
  } = useAppConfig()

  return {
    // Customizer
    isCustomizerOpen,

    // Vertical Menu
    isVerticalMenuCollapsed,

    // Skin
    skin,
    skinOptions,

    // Content Width
    contentWidth,
    contentWidthOptions,

    // RTL
    isRTL,

    // routerTransition
    routerTransition,
    routerTransitionOptions,

    // Layout Type
    layoutType,
    layoutTypeOptions,

    // NavMenu Hidden
    isNavMenuHidden,

    // Navbar
    navbarColors,
    navbarTypes,
    navbarBackgroundColor,
    navbarType,

    // Footer
    footerTypes,
    footerType,
  }
}
